import Page from 'shared/types/Page'

const filterPages = (pages: Page[] | null, position: String | false) => {

    let filteredPages: Page[] = []

    if (pages) {
        filteredPages = pages.filter((page) => {
            return (page.showInMenu === position)
        })
    }

    return filteredPages
}

export default filterPages